import { Component, OnInit, OnDestroy } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components';
import { BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { UserProfileModel } from 'lib/ng2-sapmp/src/models';
import { UserListService } from '../shared/providers/userList.service';
import { ReviewOrderProductModel } from '../review-order-product';
import { Router, ActivatedRoute } from '@angular/router';
import { LicensePricingService, AdobeAnalyticsService, AuthenticationService, UtilityService } from 'lib/ng2-sapmp/src/providers';
import { ANALYTICS_CONSTANTS } from 'config';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot/mobile-pivot.model';
declare var logoutCurrentUser: any;
declare var ENV_PORTAL;
@Component({
  selector: 'app-cancel-product',
  templateUrl: './cancel-product.component.html',
  providers: [UserListService, LicensePricingService, AdobeAnalyticsService],
  styleUrls: ['./cancel-product.component.scss'],
})
export class CancelProductComponent implements OnInit, OnDestroy {

  cancelProductDetail: any = null;
  quantity: number;
  unitPrice: number;
  totalPrice: number;
  user: UserProfileModel;
  errorMessage: string;
  reviewModel: ReviewOrderProductModel;
  subscriptionId: string;
  pivots: Array<MobilePivotModel>;
  impoErr = false;
  billingClientId: string;
  constructor(private pageloaderService: PageLoaderService, private breadCrumbService: BreadCrumbService,
    private userListService: UserListService, private router: Router, private licensePricingService: LicensePricingService,
    private adobeAnalyticsService: AdobeAnalyticsService, private authenticationService: AuthenticationService,
    private utilityService: UtilityService, private activatedRoute: ActivatedRoute) {
    this.pivots = new Array<MobilePivotModel>();

  }

  ngOnInit() {
    this.pivots.push({ label: 'Manage Products', routerLink: '/manage' });
    this.pivots.push({ label: 'Console dashboard', routerLink: '/dashboard' });
    this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);
    if (sessionStorage.getItem('singleUserDetail') === null) {
      this.router.navigate(['/home']);
    } else {
      this.pageloaderService.setPageLoaderStatus(false);
      document.body.classList.add('manageproduct-page');
      document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
      this.user = JSON.parse(sessionStorage.getItem('user')).user;
      this.breadCrumbService.setCurrentBreadCrumb({ label: 'Remove all licenses', routerLink: this.router.routerState.snapshot.url });
      this.cancelProductDetail = JSON.parse(sessionStorage.getItem('singleUserDetail'));
      this.billingClientId = this.utilityService.formatTelephoneNumber(this.cancelProductDetail.billingClientId);
      const requestObject = {};
      requestObject['credentialType'] = 'MOBILEIDENTIFIER';
      requestObject['credentialId'] = this.cancelProductDetail.billingClientId;
      requestObject['dcmCode'] = this.cancelProductDetail.serviceOfferCode;
      this.licensePricingService.getPricingForOwenedQty(requestObject).subscribe(response => {
        this.impoErr = false;
        if (response) {
          console.log(this.cancelProductDetail.quantity);
          this.unitPrice = Number(response.unitPrice);
          this.quantity = Number(response.quantity);
          this.totalPrice = Number(response.totalPrice);
          this.subscriptionId = response.purchaseIdentifier;
          if (response.quantity === this.cancelProductDetail.quantity) {
            this.errorMessage = '';
          } else {
            this.impoErr = true;
            // tslint:disable-next-line:max-line-length
            this.errorMessage = `<p> We were unable to process your request to product licenses. If you need help, call 866.241.6568 (TTY: 866.241.6567) Monday - Friday, 7 a.m. - 9 p.m. ET. Or you can chat with an expert during weekday calling hours, and from 8 a.m. - 5 p.m. ET on Saturday and Sunday </p>`;
          }
        }
        this.pageloaderService.setPageLoaderStatus(true);
      }, error => {
        this.impoErr = true;
        this.pageloaderService.setPageLoaderStatus(true);
        this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
        this.handleError(error);
      });
      this.createPageLoadProperties(this.cancelProductDetail.serviceOfferCode,
        this.router.routerState.snapshot.url,
        'Manage Product Cancel');
    }
  }

  // Page Load
  createPageLoadProperties(dcmcode, url: string, title: string) {
    const dataLayer = {};
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = ANALYTICS_CONSTANTS.FRIENDLY_NAME_MANAGE_CANCEL;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_LICENSE_MANAGEMNET_REMOVE;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = 'EN';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_SKU] = dcmcode;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'shoplogin';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Service';
    if (ENV_PORTAL === 'fnabc') {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_FIRSTNET_FLAG] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_1;
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_FIRST_NET_USER_ROLE] = ANALYTICS_CONSTANTS.GLOBAL_USER_FIRST_NET_USER_ROLE_VALUE;
    }
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }

  private handleError(error) {
    if (error) {
      if (error.status === 401) {
        this.errorMessage = 'Session expired. Please login again.';
        logoutCurrentUser(true);
      } else if (error.status === 400) {
        if (error.error[0]) {
          this.errorMessage = JSON.stringify(error.error[0]);
        } else if (error.error) {
          this.errorMessage = error.error;
        } else {
          this.errorMessage = 'Can not add more than max-qty';
        }
      } else {
        this.errorMessage = 'We couldn\'t complete your request. Please try again later.';
      }
      this.utilityService.loadFocusOnTop();
    } else {
      throw error;
    }
  }

  private goToReviewOrderPage() {
    this.reviewModel = new ReviewOrderProductModel();
    this.reviewModel.product = this.cancelProductDetail.specName;
    this.reviewModel.fan = this.cancelProductDetail.brokerAccountClientId;
    this.reviewModel.ctn = this.billingClientId;
    this.reviewModel.description = this.cancelProductDetail.productDesc;
    this.reviewModel.initialLicense = this.quantity;
    this.reviewModel.modifiedLicense = this.quantity;
    this.reviewModel.initialAmount = this.totalPrice;
    this.reviewModel.modifiedAmount = - this.totalPrice;
    this.reviewModel.unitPrice = this.unitPrice;
    this.reviewModel.initialUnitPrice = this.unitPrice;
    this.reviewModel.totalAmount = 0.00;
    this.reviewModel.serviceOfferCode = this.cancelProductDetail.serviceOfferCode;
    this.reviewModel.subscriptionId = this.subscriptionId;
    this.reviewModel.type = 'RemoveAll';
    this.reviewModel.backUrl = '/manageProduct/cancel-product';
    sessionStorage.setItem('reviewModel', JSON.stringify(this.reviewModel));
    this.router.navigate(['/manageProduct/revieworderproduct']);
  }

  private cancel() {
    this.router.navigate(['/manageProduct'], { relativeTo: this.activatedRoute });
  }

  ngOnDestroy() {
    this.pageloaderService.setPageLoaderStatus(true);
  }
}
